var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
var StyledLabel = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme, required = _a.required;
    return "\n    color: ".concat(theme.colorContent(), ";\n    font-size: .7rem;\n    line-height: .7rem;\n    padding: 0rem .3rem .3rem .3rem;\n    display: flex;\n    align-items: center;\n\n    ").concat(required
        ? "&::before {\n      content: \"\u2022\";\n      color: ".concat(theme.colorRequired(), ";\n      margin-right: 3px;\n      font-size: 1rem;\n\n    }")
        : "", "\n  ");
});
var Label = function (_a) {
    var children = _a.children, htmlFor = _a.htmlFor, required = _a.required, style = _a.style;
    return (React.createElement(StyledLabel, { htmlFor: htmlFor, required: required, style: style }, children));
};
export default Label;
var templateObject_1;
